/* eslint-disable import/no-dynamic-require */

const generateAchievement = ({
  grey, bronze, silver, gold,
}) => ({
  grey,
  bronze,
  silver,
  gold,
  current: 'grey',
  getImage: (percent) => {
    if (percent >= 0.75) return gold

    if (percent >= 0.5) return silver

    if (percent >= 0.1) return bronze

    return grey
  },
})

const STREET = {
  id: 'street',
  title: 'Улица',
  maxPoints: 12,
  route: '/lesson/1',
  image: require('./assets/street.jpg'),
  achievement: generateAchievement({
    grey: require('./assets/achievements/TraficLightGrey.svg'),
    bronze: require('./assets/achievements/TraficLightBronze.svg'),
    silver: require('./assets/achievements/TraficLightSilver.svg'),
    gold: require('./assets/achievements/TraficLightGold.svg'),
  }),
}

const HOUSE = {
  id: 'house',
  title: 'Дом',
  maxPoints: 12,
  route: '/lesson/2',
  image: require('./assets/house.jpg'),
  achievement: generateAchievement({
    grey: require('./assets/achievements/PhoneGrey.svg'),
    bronze: require('./assets/achievements/PhoneBronze.svg'),
    silver: require('./assets/achievements/PhoneSilver.svg'),
    gold: require('./assets/achievements/PhoneGold.svg'),
  }),
}

const ROBOT = {
  id: 'robot',
  title: 'Робот',
  maxPoints: 16,
  route: '/lesson/3',
  image: require('./assets/robots.jpg'),
  achievement: generateAchievement({
    grey: require('./assets/achievements/RobotGrey.svg'),
    bronze: require('./assets/achievements/RobotBronze.svg'),
    silver: require('./assets/achievements/RobotSilver.svg'),
    gold: require('./assets/achievements/RobotGold.svg'),
  }),
}

const STORE = {
  id: 'store',
  title: 'Интернет-магазин',
  maxPoints: 10,
  route: '/lesson/4',
  image: require('./assets/store.jpg'),
  achievement: generateAchievement({
    grey: require('./assets/achievements/ToasterGrey.svg'),
    bronze: require('./assets/achievements/ToasterBronze.svg'),
    silver: require('./assets/achievements/ToasterSilver.svg'),
    gold: require('./assets/achievements/ToasterGold.svg'),
  }),
}

const BLOG = {
  id: 'blog',
  title: 'Видеоблог',
  maxPoints: 10,
  route: '/lesson/5',
  image: require('./assets/blog.jpg'),
  achievement: generateAchievement({
    grey: require('./assets/achievements/VRGrey.svg'),
    bronze: require('./assets/achievements/VRBronze.svg'),
    silver: require('./assets/achievements/VRSilver.svg'),
    gold: require('./assets/achievements/VRGold.svg'),
  }),
}

const PARTY = {
  id: 'party',
  title: 'Чат',
  maxPoints: 6,
  route: '/lesson/6',
  image: require('./assets/party.jpg'),
  achievement: generateAchievement({
    grey: require('./assets/achievements/BallGrey.svg'),
    bronze: require('./assets/achievements/BallBronze.svg'),
    silver: require('./assets/achievements/BallSilver.svg'),
    gold: require('./assets/achievements/BallGold.svg'),
  }),
}

const HUB = {
  id: 'hub',
  title: 'Хаб',
  route: '/hub',
}
const TEST = {
  id: 'test',
  title: 'Тест',
  route: '/test',
}
const POLL = {
  id: 'poll',
  title: 'Опрос',
  route: '/poll',
}
const DASHBOARD = {
  id: 'dashboard',
  title: 'Дэшборд',
  route: '/dashboard',
}

const USER_ROUTES_BY_GRADE = {
  0: [STREET, HOUSE, ROBOT, HUB],
  // 0: [ROBOT, HUB],
  1: [STREET, HOUSE, STORE, BLOG, TEST, HUB],
  2: [STORE, BLOG, PARTY, TEST, POLL, DASHBOARD, HUB],
}

const ALL_LESSONS = [STREET, HOUSE, ROBOT, STORE, BLOG, PARTY]

class UserStory {
  constructor({ router, store, grade = 2 }) {
    this.inited = false
    this.router = router
    this.store = store
    this.currentIndex = -1
    this.currentRoute = null
    this.grade = 0

    this.startDate = null

    this.setRoutes(grade)

    this.overflowRoutes = []
  }

  prepareState() {
    const { store, routes } = this
    store.commit('setResults', this.getResultsFromRoutes(routes))
  }

  // eslint-disable-next-line class-methods-use-this
  getResultsFromRoutes(routes) {
    return routes
      .filter(route => !!route.maxPoints)
      .map(({
        title, image, maxPoints, id, achievement,
      }) => ({
        id,
        title,
        image,
        maxPoints,
        achievement,
        attempts: 0,
        score: 0,
        time: 0,
      }))
  }

  setGrade(grade) {
    this.grade = grade
    this.inited = true

    this.setRoutes(grade)

    this.currentIndex = -1

    return this
  }

  setOverflowRoutes(routeID) {
    const route = ALL_LESSONS.find(i => i.id === routeID)
    if (route) {
      this.store.commit('setOverflowRoutes', true)
      this.currentIndex = 0
      this.routes = [route, HUB]
    }

    return this
  }

  setRoutes(grade) {
    this.routes = USER_ROUTES_BY_GRADE[grade]

    if (this.routes) this.prepareState()

    return this
  }

  goTo(id) {
    this.currentIndex = this.routes.indexOf(this.routes.find(i => i.id === id))
    this.moveRouter()
  }

  moveRouter() {
    const {
      routes, currentIndex, router,
    } = this

    router.push(routes[currentIndex].route)
    this.currentRoute = routes[currentIndex]
  }

  updateCurrentByPath(path) {
    const route = this.routes.find(i => i.route === path)
    this.currentRoute = route
    this.currentIndex = this.routes.indexOf(route)
  }

  start() {
    this.startDate = new Date()
  }

  stop(obj) {
    if (!obj) return
    const {
      currentIndex, startDate, store, currentRoute,
    } = this
    const { result } = obj

    if (currentIndex > -1 && !!currentRoute.maxPoints) {
      const seconds = new Date().getTime() - (startDate || new Date()).getTime()

      const { results } = store.state

      if (!results.map(i => i.id).includes(currentRoute.id)) {
        const newResults = this.getResultsFromRoutes(this.routes)
        store.commit('setResults', [...results, ...newResults])
      }

      store.commit('setResult', { seconds, result, id: currentRoute.id })
    }
  }

  next(obj) {
    const { routes, currentIndex } = this

    this.stop(obj)
    this.currentIndex = Math.min(routes.length - 1, currentIndex + 1)

    this.moveRouter()

    return this
  }
}

export { ALL_LESSONS }

export {
  STREET, HOUSE, ROBOT, STORE, BLOG, PARTY, HUB, TEST, POLL, DASHBOARD,
}
export default UserStory
